import { useEffect } from "react";

const SITE_URL = "https://justdessertme.co.nz";

const setMetaByName = (name, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setMetaByProperty = (property, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (url) => {
  let el = document.head.querySelector("link[rel='canonical']");
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
};

/**
 * Updates page-specific SEO metadata (title, description, canonical, OG, Twitter).
 * Call once per top-level page component.
 */
export const usePageMeta = ({ title, description, path = "/", image }) => {
  useEffect(() => {
    const fullTitle = title || "Just Dessert Me — Waikato's Premiere Dessert Destination";
    const fullUrl = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMetaByName("description", description);

    setMetaByProperty("og:title", fullTitle);
    setMetaByProperty("og:description", description);
    setMetaByProperty("og:url", fullUrl);
    if (image) setMetaByProperty("og:image", image);

    setMetaByName("twitter:title", fullTitle);
    setMetaByName("twitter:description", description);
    if (image) setMetaByName("twitter:image", image);

    setCanonical(fullUrl);
  }, [title, description, path, image]);
};

export { SITE_URL };
